import { render, staticRenderFns } from "./DistributorForm.vue?vue&type=template&id=0658cd1c&scoped=true"
import script from "./DistributorForm.vue?vue&type=script&lang=js"
export * from "./DistributorForm.vue?vue&type=script&lang=js"
import style0 from "./DistributorForm.vue?vue&type=style&index=0&id=0658cd1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0658cd1c",
  null
  
)

export default component.exports